import { InjectionToken } from '@angular/core';

export const WindowToken = new InjectionToken('Window');
export function windowProvider() { return window; }



// WEBPACK FOOTER //
// /home/wzc/dev/angular/angular/aio/src/app/shared/window.ts